import {EventEmitter, Input, Output, Directive, ElementRef} from '@angular/core';
import {FieldTableDto} from '@tj/tj-dmp-lib-api';

@Directive()
export abstract class AbstractDisplayComponent {
  @Input() field: FieldTableDto;
  @Input() value: any;
  @Input() containerParent: HTMLTableCellElement;
  /** @Deprecated */
  @Input() isWrite = false;

  @Output() valueChange = new EventEmitter();

  alerts: Set<string> = new Set<string>();
  display: string = null;
  displayHover: string = null;

  constructor(/* protected elRef:ElementRef,
    protected renderer: Renderer2 */) {

  }



    getAlertsTooltip() {
        return Array.from(this.alerts).join('\n');
    }

}
